import { formatDate } from './formatters'

interface DadosDaSituacao {
  statusTurma: 'SOLICITADA' | 'ATIVA'
  dataPagamento?: string | null
  dataVencimento?: string | null
}

export interface SituacaoDaTurma {
  cor?: string
  texto: string
}

export function situacaoDaTurma({
  statusTurma,
  dataPagamento,
  dataVencimento,
}: DadosDaSituacao): SituacaoDaTurma {
  if (statusTurma === 'SOLICITADA') return { cor: 'orange', texto: 'Em análise' }
  if (dataPagamento) return { cor: 'green', texto: `Pago · ${formatDate(dataPagamento)}` }
  if (dataVencimento && new Date(dataVencimento) < new Date()) {
    return { cor: 'red', texto: 'Vencida' }
  }
  return { texto: 'Em aberto' }
}
